<template>
  <div class="quizz">
    <div class="question-bloc">
      <div class="step-infos">
        {{ index + 1 }} / {{ nbQuestion }}
      </div>
      <slot v-if="customQuestion" name="custom-question"></slot>
      <div v-else class="question">
        <p class="title">{{ questionName }}</p>
      </div>
    </div>
    <div class="answers-bloc" :class="{ 'answered': showResults, 'can-change-answer': canChangeAnswer }">
      <div
        v-for="answer in question.answers"
        :key="answer.name"
        class="answer"
        :class="{
          'right': showResults && answer.isValid && showStatus,
          'wrong': showResults && answer.name === userAnswer && showStatus,
          'answered': answer.name === userAnswer && !showStatus && showResults }"
        @click="answerQuestion(answer)"
      >
        <p class="index" v-show="showIndex">
          {{ answer.name }}
        </p>
        <p class="label">
          {{ answer.label }}
        </p>
      </div>
    </div>
    <transition name="fade">
      <button
        v-show="showResults && showNextButton"
        class="button next-button"
        @click="nextQuestion"
      >
        {{ nextButtonLabel }}
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Quizz',
  props: {
    customQuestion: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    question: {
      type: Object,
      required: true
    },
    questionName: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    nbQuestion: {
      type: Number,
      required: true
    },
    showIndex: {
      type: Boolean,
      required: false,
      default: true
    },
    emitStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    showStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    canChangeAnswer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showResults: false,
      answerTimeout: null,
      userAnswer: '',
      showNextButton: false
    }
  },
  computed: {
    nextButtonLabel () {
      return this.index + 1 === this.nbQuestion
        ? 'Continuer'
        : 'Question suivante'
    }
  },
  methods: {
    nextQuestion () {
      if (this.showResults) {
        this.showResults = false
        this.$emit('next-question')
        clearTimeout(this.answerTimeout)
      }
    },
    answerQuestion (answer) {
      if (!this.showResults) {
        this.showNextButton = false
        if (!this.showResults || this.canChangeAnswer) {
          this.userAnswer = answer.name
          this.answerTimeout = setTimeout(() => {
            if (this.emitStatus) {
              this.$emit('answered', answer.status)
            } else {
              this.$emit('answered', answer.isValid ? 'right' : 'wrong')
            }
            this.showResults = true
          }, this.showStatus ? 0 : 100)
          window.setTimeout(() => {
            this.showNextButton = true
          }, this.customQuestion ? 1000 : 0)
        }
      }
    }
  }
}
</script>

<style lang=scss>
.quizz {
  .question-bloc {
    background-color: #fff;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
    border-radius: $radius-sm;
    height: 250px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .step-infos {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 400;
      font-family: $secondary-font;
      color: $light-text-color;
    }
    .question {
      font-size: 1.2rem;
      padding: 0 15px;
      .title {
        font-size: 1.4rem;
        font-weight: 700;
      }
      p:not(.title) {
        font-size: 1.1rem;
      }
    }
  }
  .answers-bloc {
    padding-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .answer + .answer {
      margin-left: 15px;
    }
    .answer {
      min-width: 32%;
      flex: 1 1 0;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 2px 1px 5px rgba(128, 128, 128, 0.25);
      border-radius: $radius-md;
      background-color: rgba(255, 255, 255, 0.85);
      border: 1px solid $secondary-color;
      height: 80px;
      padding: 2px;
      cursor: pointer;
      color: $secondary-color;
      .label {
        font-weight: 400;
        padding: 5px 15px;
        text-align: center;
        transition: $color-transition;
        font-size: 0.95rem;
      }
      &.wrong {
        border: 3px solid #ff1010;
        color: #ff1010;
      }
      &.right {
        border: 3px solid #1bb91f;
        color: #1bb91f;
        .label {
          font-weight: 700;
        }
      }
      &.answered {
        background-color: $secondary-color;
        color: #fff;
        font-weight: 700;
      }
      &:hover {
        background-color: rgba(255, 255, 255, 1);
      }
    }
  }
  .next-button {
    min-width: 190px;
    margin: 40px auto 0 auto;
  }
}
</style>
